// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Calendar__Wrapper_2XWmY","Title":"Calendar__Title_3c4QH","Events":"Calendar__Events_TCgji grid grid--col-12"};